// components/OrderFilters.jsx

import React from "react";

import {
  FiSearch,
} from "react-icons/fi";

import {
  ORDER_STATUS_LABELS,
  PAYMENT_METHODS,
  PAYMENT_STATUS_LABELS,
} from "../utils/orderConstants";


const OrderFilters = ({
  filters,

  loading = false,

  onChange,

  onSearch,

  onReset,
}) => {
  const handleKeyDown = (
    event
  ) => {
    if (
      event.key ===
      "Enter"
    ) {
      onSearch?.();
    }
  };

  return (
    <div
      className="order-filter-card"
    >
      <div
        className="order-filter-grid"
      >
        <div
          className="order-filter-field search"
        >
          <label>
            Search
          </label>

          <div
            className="order-search-box"
          >
            <FiSearch />

            <input
              type="text"
              value={
                filters?.search ||
                ""
              }
              onChange={(
                event
              ) =>
                onChange?.(
                  "search",
                  event.target.value
                )
              }
              onKeyDown={
                handleKeyDown
              }
              placeholder="Order no, customer, mobile, SKU, tracking..."
            />
          </div>
        </div>


        <div
          className="order-filter-field"
        >
          <label>
            Order Status
          </label>

          <select
            value={
              filters?.status ||
              ""
            }
            onChange={(
              event
            ) =>
              onChange?.(
                "status",
                event.target.value
              )
            }
          >
            <option value="">
              All Statuses
            </option>

            {Object.entries(
              ORDER_STATUS_LABELS
            ).map(
              ([
                value,
                label,
              ]) => (
                <option
                  key={
                    value
                  }
                  value={
                    value
                  }
                >
                  {label}
                </option>
              )
            )}
          </select>
        </div>


        <div
          className="order-filter-field"
        >
          <label>
            Payment
          </label>

          <select
            value={
              filters
                ?.paymentStatus ||
              ""
            }
            onChange={(
              event
            ) =>
              onChange?.(
                "paymentStatus",
                event.target.value
              )
            }
          >
            <option value="">
              All Payments
            </option>

            {Object.entries(
              PAYMENT_STATUS_LABELS
            ).map(
              ([
                value,
                label,
              ]) => (
                <option
                  key={
                    value
                  }
                  value={
                    value
                  }
                >
                  {label}
                </option>
              )
            )}
          </select>
        </div>


        <div
          className="order-filter-field"
        >
          <label>
            Method
          </label>

          <select
            value={
              filters
                ?.paymentMethod ||
              ""
            }
            onChange={(
              event
            ) =>
              onChange?.(
                "paymentMethod",
                event.target.value
              )
            }
          >
            <option value="">
              All Methods
            </option>

            {PAYMENT_METHODS.map(
              (
                method
              ) => (
                <option
                  key={
                    method.value
                  }
                  value={
                    method.value
                  }
                >
                  {method.label}
                </option>
              )
            )}
          </select>
        </div>


        <button
          type="button"
          className="order-filter-search-btn"
          onClick={
            onSearch
          }
          disabled={
            loading
          }
        >
          <FiSearch />

          Search
        </button>


        <button
          type="button"
          className="order-filter-reset-btn"
          onClick={
            onReset
          }
          disabled={
            loading
          }
        >
          Reset
        </button>
      </div>
    </div>
  );
};


export default
  OrderFilters;